import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const SectionWrapper = styled.div`
  padding: ${Spacing.S24};
`
